import React from 'react';

// Tenant context (Phase B4 stub).
//
// There is no `tenants` table today (REFACTOR-PLAN §3.1). Phase D adds
// it and the require-tenant middleware. This context is a placeholder
// so the component tree has the wiring in place when Phase D's
// branding/copy/colors start flowing through it.
//
// Shape (today):
//   { id: 1, settings: null }   // hardcoded "Empire" tenant
//
// Shape (Phase D):
//   {
//     id,                        // tenant_id
//     settings: {
//       productName,             // "Monarch" by default
//       businessName,            // "Empire Tea & Coffee" today
//       supportEmail, fromEmail,
//       legalEntities,           // replaces hardcoded ETC/NBT
//       brandColors,             // tokens.css palette
//       logoInternalUrl,
//       logoExternalUrl,
//       pwaName,
//       timezone,
//       defaultLocale,
//       careersFormCopy,
//     },
//   }

const TenantContext = React.createContext({ id: 1, settings: null });

export { TenantContext };
export default TenantContext;
